import {httpNewApi, httpApiV3, useVzFetch} from '~/composables/useVzFetch';
import {
  AccountChangeEmailPayload,
  AccountChangePasswordPayload,
  AccountChangePhonePayload,
  AccountResponse,
  VZResponse
} from '~/types/api';

export function getAccount() {
  return useVzFetch(
      `${httpApiV3}/personal/user/account`
  ) as Promise<AccountResponse>
}

export function getApiKey() {
  return useVzFetch(
      `${httpNewApi}/personal/account/get-api`,
      { method: 'post' }
  ) as Promise<AccountResponse>
}

export function newApiKey() {
  return useVzFetch(
      `${httpNewApi}/personal/account/generate-api-key`,
      { method: 'post' }
  ) as Promise<{key: string, error?: string}>
}

// export function setAccountEmail(body) {
//   return useVzFetch(
//       `${httpNewApi}/personal/user/edit`,
//       { method: 'post', body }
//   ) as Promise<{ timeout_second?: number, error?: any, linkMessage?: string }>
// }
//
// export function setAccountPassword(body) {
//   return useVzFetch(
//       `${httpNewApi}/personal/account/set-password`,
//       { method: 'post', body }
//   ) as Promise<{ token?: string, message?: string, error?: any }>
// }

export function setUserAccountPassword(body: AccountChangePasswordPayload) {
  return useVzFetch(
      `${httpApiV3}/personal/user/account/password`,
      { method: 'post', body, manual: true }
  ) as Promise<VZResponse<{token?: string}>>
}

export function setUserAccountPhone(body: AccountChangePhonePayload) {
  return useVzFetch(
      `${httpApiV3}/personal/user/account/phone`,
      { method: 'post', body, manual: true }
  ) as Promise<VZResponse<{required?: Array<string>}>>
}

export function setUserAccountEmail(body: AccountChangeEmailPayload) {
  return useVzFetch(
      `${httpApiV3}/personal/user/account/email`,
      { method: 'post', body, manual: true }
  ) as Promise<VZResponse<{required?: Array<string>}>>
}

export function setUserAccountUsername(body: { username: string }) {
  return useVzFetch(
      `${httpApiV3}/personal/user/account/username`,
      { method: 'post', body }
  ) as Promise<VZResponse<{required?: Array<string>}>>
}

export function deleteAccount() {
  return useVzFetch(
      `${httpNewApi}/personal/account/delete`,
      { method: 'post' }
  ) as Promise<VZResponse<{}>>
}

// export function setAccountPhone(body: { phone: string, link?: boolean }) {
//   return useVzFetch(
//       `${httpNewApi}/personal/user/edit`,
//       { method: 'post', body }
//   ) as Promise<{ linkMessage?: string, timeout_second?: number, error?: any, success?: boolean, user?: { email: string, phone: string }, token?: string }>
// }
